import __var_0__ from '@stdlib/assert/is-integer';
import __var_1__ from '@stdlib/ndarray/base/ind';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var isInteger = __var_0__.isPrimitive;
var getIndex = __var_1__;


// FUNCTIONS //

/**
* Returns a method for returning an array element.
*
* @private
* @param {StringArray} mode - specifies how to handle indices which exceed array dimensions
* @returns {Function} method for returning an array element
*/
function wrap( mode ) {
	var M = mode.length;
	return get;

	/**
	* Returns an array element.
	*
	* @private
	* @param {...integer} idx - indices
	* @throws {TypeError} provided indices must be integer valued
	* @throws {RangeError} index exceeds array dimensions
	* @returns {*} array element
	*/
	function get() {
		/* eslint-disable no-invalid-this */
		var len;
		var idx;
		var ind;
		var i;

		len = arguments.length;
		idx = this._offset;
		for ( i = 0; i < len; i++ ) {
			if ( !isInteger( arguments[ i ] ) ) {
				throw new TypeError( 'invalid argument. Indices must be integer valued. Argument: '+i+'. Value: `'+arguments[i]+'`.' );
			}
			ind = getIndex( arguments[ i ], this._shape[ i ]-1, mode[ i%M ] );
			idx += this._strides[ i ] * ind;
		}
		return this._buffer[ idx ];
	}
}


// EXPORTS //
export default wrap;
